import { render, staticRenderFns } from "./lkuArinvirgin.vue?vue&type=template&id=6457100e"
import script from "./lkuArinvirgin.vue?vue&type=script&lang=js"
export * from "./lkuArinvirgin.vue?vue&type=script&lang=js"
import style0 from "./lkuArinvirgin.vue?vue&type=style&index=0&id=6457100e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports